import { useState } from "react";
import { loadVendorDetails } from "../services/vendorEnquiryService";

const useLoadVendorDetailById = () => {

    const [vendorDetails, setVendorList] = useState([]);

    const fetchVendorDetail = async (vendorID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid"),  p_partyid: vendorID, };

        try {
            const data = await loadVendorDetails(para);
            if (data && data.length > 0) {
                setVendorList(data);
                
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    }

    const loadVendorDetail = async (vendorID) => {
        await fetchVendorDetail(vendorID);
    }

    return {vendorDetails, setVendorList,loadVendorDetail};

}
export default useLoadVendorDetailById;